



const imgURLRoot = `${process.env.PUBLIC_URL}/fontpreviews/`;

export default function CreateStylePreviewImage({image,colors,fontPrimary,fontSecondary,canvasWidth,canvasHeight}:{image:string,colors:string[],fontPrimary:string,fontSecondary:string,canvasWidth:string,canvasHeight:string}){

   
    // const colorHeight = canvasHeight/5;
   
    const imgURLA = `${imgURLRoot}headings/heading-${fontPrimary.replaceAll(" ", "-").toLowerCase()}.png`;
    const imgURLB = `${imgURLRoot}paragraphs/paragraph-${fontSecondary.replaceAll(" ", "-").toLowerCase()}.png`;

    return <div className="style-preview-card" style={{width:canvasWidth,height:canvasHeight,display:"flex",flexDirection:"column",borderRadius:"4px",overflow:"hidden"}}>
        <div key="heading" className="style-heading flex-row " style={{background:colors[3],fontSize:".5em",display:"flex",justifyContent:"space-between",padding:"1.5%"}} >
            <div style={{fontWeight:"bold",fontSize:"1.5em"}}>LOGO</div>
            <div style={{background:colors[2],borderRadius:"3px",padding:"1.5% 3%" }}>BUTTON</div>
        </div>
        <div key="bg" className="flex-column style-content center-all"  style={{height:"100%", textAlign:"center",color:"white", backgroundImage:`url(${image})`,backgroundSize:"cover",backgroundPosition:"center 25%",boxShadow:"inset 0 1000px "+colors[0]+"77"}}>
        
            <img alt="font-a" src={imgURLA} style={{width:"70%",margin:`0 auto -10%`}}/>
            <img alt ="font-b" src={imgURLB} style={{width:"100%",margin:"0 auto"}}/>


        </div>
        <div key="footer" className="style-footer" style={{background:colors[2],height:"25%"}}>
            <div key="colors" className="flex-row " style={{height:"100%",width:"60%",margin:`auto`,transform:"translateY(-50%)",borderRadius:"5px",overflow:"hidden",boxShadow:"0 0 3px 3px #00000045"}}>
                {colors.map((color,index) => {
                    if(index>4)
                        return null;
                    return <div key={color+index} style={{background:color,width:"100%",height:"100%"}}></div>
                })} 
            
            </div>
        </div>

    </div>

}